import {
  FC,
  useState,
  DetailedHTMLProps,
  InputHTMLAttributes,
  ChangeEvent,
  ReactNode,
  FocusEvent,
  forwardRef,
  ForwardedRef,
  SyntheticEvent,
} from 'react'
import { v4 as uuidv4 } from 'uuid'
import { cn } from '@bem-react/classname'
import { Transition } from 'react-transition-group'
import { Memo } from '@/hoc/Memo'
import './Field.scss'

const cnField = cn('Field')

export type FieldType = 'text' | 'number' | 'password' | 'email'

export interface FieldSchema
  extends DetailedHTMLProps<
    InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  uid?: string
  type?: FieldType
  label?: string
  name: string
  isSmallLabel?: boolean
  errors?: string
  placeholder?: string
  required?: boolean
  isSmall?: boolean
  readonly?: boolean
  disabled?: boolean
  iconLeft?: ReactNode | string
  iconRight?: ReactNode | string
  noArrow?: boolean
  handleOnBlur?: (e?: SyntheticEvent) => void
}

export const Field: FC<FieldSchema> = Memo(
  forwardRef(
    (
      {
        uid = 'input-' + uuidv4(),
        type = 'text',
        value,
        label,
        isSmallLabel,
        onChange,
        onBlur,
        name,
        required,
        errors,
        placeholder,
        isSmall = true,
        readonly = false,
        className,
        disabled,
        iconLeft,
        iconRight,
        noArrow,
        handleOnBlur,
        ...props
      }: FieldSchema,
      ref: ForwardedRef<HTMLInputElement>,
    ) => {
      const [isEye, setIsEye] = useState<boolean>(false)

      const changeType = () => {
        setIsEye(!isEye)

        // const inputElement = document.getElementById(uid)
        // if (inputElement) inputElement.focus()
      }

      const hanleChange = (e: ChangeEvent<HTMLInputElement>): void => {
        if (onChange) {
          onChange(e)
        }
      }

      const hanleBlur = (e: FocusEvent<HTMLInputElement>): void => {
        setIsEye(false)
        if (type === 'password' && onBlur) onBlur(e)
        // else onBlur && onBlur(e)
      }

      return (
        <div className={cnField(null, [className])}>
          {!!label && (
            <label
              htmlFor={uid}
              className={cnField('label', { small: isSmallLabel, required })}
            >
              <div
                className={cnField('text', { small: isSmallLabel, required })}
              >
                {label}
              </div>
            </label>
          )}
          <div className={cnField('wrap')}>
            {iconLeft && (
              <div className={cnField('icon', { left: true })}>{iconLeft}</div>
            )}
            <input
              placeholder={placeholder}
              id={uid}
              value={value}
              name={name}
              type={
                (type === 'password' && (isEye ? 'text' : 'password')) || type
              }
              autoFocus={isEye}
              onChange={hanleChange}
              onBlur={e => {
                hanleBlur(e)
                handleOnBlur && handleOnBlur(e)
              }}
              disabled={disabled}
              readOnly={readonly}
              className={cnField('input', {
                error: !!errors,
                small: isSmall,
                left: !!iconLeft,
                right: !!iconRight,
                arrow: noArrow,
              })}
              ref={ref}
              {...props}
            />

            {iconRight && (
              <div className={cnField('icon', { right: true })}>
                {iconRight}
              </div>
            )}

            {type === 'password' && (
              <button
                className={cnField('eye')}
                type='button'
                onClick={changeType}
              >
                {isEye ? (
                  <i className='fa-solid fa-eye'></i>
                ) : (
                  <i className='fa-solid fa-eye-slash'></i>
                )}
              </button>
            )}
          </div>
          <Transition in={!!errors} timeout={500} mountOnEnter unmountOnExit>
            {state => <div className={cnField('error', [state])}>{errors}</div>}
          </Transition>
        </div>
      )
    },
  ),
)
